export default {
  productTitle: {
    id: 'bo_sellers-buyback-opportunities-data-table-product-title',
    defaultMessage: 'Product title',
  },
  grade: {
    id: 'bo_sellers-buyback-opportunities-data-table-grade',
    defaultMessage: 'Grade',
  },
  marketCode: {
    id: 'bo_sellers-buyback-opportunities-data-table-market-code',
    defaultMessage: 'Market code',
  },
  priceToWinBackboxEstimation: {
    id: 'bo_sellers-buyback-opportunities-data-table-price-to-win-backbox-estimation',
    defaultMessage: 'Price to win backbox estimation',
  },
  margin: {
    id: 'bo_sellers-buyback-opportunities-data-table-margin',
    defaultMessage: 'Margin',
  },
  profitPotentialRank: {
    id: 'bo_sellers-buyback-opportunities-data-table-profit-potential-rank',
    defaultMessage: 'Profit potential rank',
  },
  createListing: {
    id: 'bo_sellers-buyback-opportunities-data-table-create-listing',
    defaultMessage: 'Create listing',
  },
  turnOnline: {
    id: 'bo_sellers-buyback-opportunities-data-table-turn-online',
    defaultMessage: 'Turn online',
  },
  updatePrice: {
    id: 'bo_sellers-buyback-opportunities-data-table-update-price',
    defaultMessage: 'Update price',
  },
  competitionLevel: {
    id: 'bo_sellers-buyback-opportunities-data-table-competition-level',
    defaultMessage: 'Competition level',
  },
  ordersVolume: {
    id: 'bo_sellers-buyback-opportunities-data-table-orders-volume',
    defaultMessage: 'Orders volume',
  },
  averageSellingPrice: {
    id: 'bo_sellers-buyback-opportunities-data-table-average-selling-price',
    defaultMessage: 'Average selling price',
  },
  high: {
    id: 'bo_sellers-buyback-opportunities-data-table-high',
    defaultMessage: 'High',
  },
  medium: {
    id: 'bo_sellers-buyback-opportunities-data-table-medium',
    defaultMessage: 'Medium',
  },
  low: {
    id: 'bo_sellers-buyback-opportunities-data-table-low',
    defaultMessage: 'Low',
  },
  veryLow: {
    id: 'bo_sellers-buyback-opportunities-data-table-very-low',
    defaultMessage: 'Very low',
  },
  profitPotentialRankDescription: {
    id: 'bo_sellers-buyback-opportunities-data-table-profit-potential-rank-description',
    defaultMessage:
      'The profit potential rank is a measure of the profit potential of a product.',
  },
  marginDescription: {
    id: 'bo_sellers-buyback-opportunities-data-table-margin-description',
    defaultMessage: 'The margin is the profit potential of a product.',
  },
  averageSellingPriceDescription: {
    id: 'bo_sellers-buyback-opportunities-data-table-average-selling-price-description',
    defaultMessage:
      'The average selling price is the average selling price of a product.',
  },
  ordersVolumeDescription: {
    id: 'bo_sellers-buyback-opportunities-data-table-orders-volume-description',
    defaultMessage: 'The orders volume is the number of orders for a product.',
  },
  competitionLevelDescription: {
    id: 'bo_sellers-buyback-opportunities-data-table-competition-level-description',
    defaultMessage:
      'The competition level is the competition level of a product.',
  },
}
